import { Component } from "react";
import { FormattedMessage, injectIntl } from "react-intl";
import { ADMIN, CHOICE_DESCRIPTION_VISIBLE, SURVEY_KEY_EDITOR } from "../../../common/constant";
import { FIELD_REQUIRED, OTHER_OPTION, TEMP_OTHER_OPTION } from "../../../ducks/surveyEditor";
import ObjectUtils, { coalesce } from "../../../utils/ObjectUtils";

import { faEdit, faGripVertical, faPlusSquare, faTimes } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import PropTypes from "prop-types";
import { Button, ButtonGroup, ButtonToolbar, Container, Dropdown, FormLabel, ModalTitle, Row } from "react-bootstrap";
import Col from "react-bootstrap/Col";
import DropdownItem from "react-bootstrap/DropdownItem";
import DropdownMenu from "react-bootstrap/DropdownMenu";
import DropdownToggle from "react-bootstrap/DropdownToggle";
import FormGroup from "react-bootstrap/FormGroup";
import Modal from "react-bootstrap/Modal";
import ModalHeader from "react-bootstrap/ModalHeader";
import FormControl from "../../../../node_modules/react-bootstrap/FormControl";
import { QuestionIcon } from "../../../utils/QuestionUtils";
import Checkbox from "../../common/Checkbox";
import Circle from "../../common/Circle";
import Radio from "../../common/Radio";
import TrashButton from "../../common/TrashButton";
import Visibility from "../../common/VisibleContainer";
import InfoTooltip from "../surveyView/questions/renderer/InfoTooltip";
import Date from "./questionTypes/Date";
import MultiChoice from "./questionTypes/MultiChoice";
import Number from "./questionTypes/Number";
import Text from "./questionTypes/Text";

/**
 * Represents a choice (option) in the question of multi-question type.
 * Choices can be reordered, added, renamed or removed.
 */
class Choice extends Component {
  constructor(props) {
    super(props);

    this.state = {
      showChoiceKey: false
    };
  }

  handleDescriptionView(e) {
    const { pageName, question, changeQuestionField, choiceName, choiceTarget } = this.props;

    changeQuestionField(
      pageName,
      question.name,
      [CHOICE_DESCRIPTION_VISIBLE],
      e.target.checked,
      choiceName,
      choiceTarget
    );
  }

  handleRequiredChanged(e) {
    const { pageName, question, changeQuestionField, choiceName, choiceTarget } = this.props;

    changeQuestionField(pageName, question.name, "required", e.target.checked, choiceName, choiceTarget);
  }

  handleVisibleChanged(e) {
    const { pageName, question, changeQuestionField, choiceName, choiceTarget } = this.props;

    changeQuestionField(pageName, question.name, "visible", e.target.checked, choiceName, choiceTarget);
  }

  handleChange(e, propertyName) {
    const { pageName, question, changeQuestionField, choiceName, choiceTarget } = this.props;

    changeQuestionField(pageName, question.name, propertyName, e.target.value, choiceName, choiceTarget);
  }

  handleAddQuestionChoice() {
    const { pageName, question, choiceTarget, addQuestionChoice } = this.props;
    addQuestionChoice(pageName, question.name, choiceTarget);
  }

  handleEditQuestionChoice() {
    const { pageName, question, choiceName, choiceTarget, editSubchoice } = this.props;
    editSubchoice(pageName, question.name, choiceName, choiceTarget);
  }

  handleDeleteQuestionChoice() {
    const { pageName, question, choiceName, choiceTarget, removeQuestionChoice } = this.props;
    removeQuestionChoice(pageName, question.name, choiceName, choiceTarget);
  }

  handleDragStart(choiceName, choiceTarget, event) {
    event.stopPropagation();
    event.dataTransfer.effectAllowed = "copyMove";
    const dragData = JSON.stringify({
      type: "reorderChoice",
      choiceName,
      choiceTarget
    });
    event.dataTransfer.setData("text", dragData);
  }

  handleDrop(toBeReplaced, event) {
    const { pageName, question, reorderChoice, choiceTarget } = this.props;

    const dragData = JSON.parse(event.dataTransfer.getData("text"));
    if (
      "reorderChoice" === ObjectUtils.getDeepProperty(dragData, "type") &&
      choiceTarget === ObjectUtils.getDeepProperty(dragData, "choiceTarget")
    ) {
      reorderChoice(pageName, question.name, dragData.choiceName, toBeReplaced, choiceTarget);
    }
  }

  handleQuestionChange(e, propertyName) {
    const { pageName, question, changeQuestionField, choiceName } = this.props;

    changeQuestionField(pageName, question.name, propertyName, e.target.checked ? choiceName : "");
  }

  handleSelect(propertyName, value) {
    const { pageName, question, changeQuestionField, choiceName, choiceTarget } = this.props;
    changeQuestionField(pageName, question.name, propertyName, value, choiceName, choiceTarget);
  }

  handleRequired(e) {
    const { pageName, question, changeQuestionField, choiceName, choiceTarget } = this.props;
    changeQuestionField(pageName, question.name, [FIELD_REQUIRED], e.target.checked, choiceName, choiceTarget);
  }

  handleOtherOption(e) {
    const { pageName, question, changeQuestionField, choiceName, choiceTarget } = this.props;
    changeQuestionField(pageName, question.name, [OTHER_OPTION], e.target.checked, choiceName, choiceTarget);
  }

  render() {
    const {
      choiceName,
      choiceText,
      pageName,
      question,
      letter,
      infoText,
      choiceDescriptionVisible,
      hasSubchoice,
      type,
      setValidator,
      setValidatorProperty,
      changeQuestionField,
      addQuestionChoice,
      removeQuestionChoice,
      reorderChoice,
      confirmSubchoice,
      cancelSubchoice,
      choiceTarget,
      intl,
      loadPredefinedList,
      editable,
      required,
      showRequiredToggle,
      visible,
      showVisibleToggle,
      choiceKey
    } = this.props;

    const checkedExclusive =
      question["choiceExclusive"] === choiceName || question["tempChoiceExclusive"] === choiceName;
    const messagePrefix =
      choiceTarget === "rows" ? "survey.editor.tooltip.table.row" : "survey.editor.tooltip.table.column";
    const choiceKey_Prefix =
      choiceTarget === "rows"
        ? "survey.editor.row.key"
        : choiceTarget === "columns"
        ? "survey.editor.column.key"
        : "survey.editor.choice.key";
    const choiceInfotext = infoText ? infoText !== "<p><br></p>" : false;
    const showInfotext = choiceDescriptionVisible ? choiceDescriptionVisible : choiceInfotext;

    return (
        <Container onDrop={this.handleDrop.bind(this, choiceName)} className="pb-2">
          <div className="bg-white px-3 pt-4 pb-2 rounded border w-100">
            <Row className="align-items-center">
              <SubChoicePopup
                hasSubchoice={hasSubchoice}
                pageName={pageName}
                question={question}
                editable={editable}
                parentChoiceName={choiceName}
                changeQuestionField={changeQuestionField}
                addQuestionChoice={addQuestionChoice}
                removeQuestionChoice={removeQuestionChoice}
                reorderChoice={reorderChoice}
                onConfirm={() => confirmSubchoice(pageName, question.name, choiceName, choiceTarget)}
                onClose={() => cancelSubchoice(pageName, question.name, choiceName, choiceTarget)}
                onRequired={(e) => this.handleRequired(e)}
                onOtherOption={(e) => this.handleOtherOption(e)}
                choiceType={type}
                setValidator={setValidator}
                setValidatorProperty={setValidatorProperty}
                letter={letter}
                loadPredefinedList={loadPredefinedList}
                intl={intl}
              />
              <Col xs="auto">
                <Button
                  draggable
                  size="sm"
                  variant="link"
                  title={intl.formatMessage({ id: messagePrefix + ".move" })}
                  onDragStart={this.handleDragStart.bind(this, choiceName, choiceTarget)}
                >
                  <FontAwesomeIcon icon={faGripVertical} />
                </Button>
              </Col>
              <Col xs="auto">{String.fromCharCode(letter)}</Col>
              <Col lg={6} md={8}>
                <FormControl
                  disabled={!editable}
                  type="text"
                  name={choiceName}
                  value={choiceText}
                  onChange={(e) => this.handleChange(e, "text")}
                />
              </Col>
              {hasSubchoice && (
                <Col xs={2}>
                  <SubchoiceType
                    disabled={!editable}
                    hasSubchoice={hasSubchoice}
                    tableChoiceType={type}
                    onSelect={this.handleSelect.bind(this)}
                    intl={intl}
                  />
                </Col>
              )}
              <Col lg={2} md={12}>
                <ButtonToolbar>
                  <ButtonGroup>
                    { hasSubchoice && (
                      <Button
                        size="sm"
                        variant="link"
                        title={intl.formatMessage({ id: "survey.editor.tooltip.table.column.edit" })}
                        onClick={this.handleEditQuestionChoice.bind(this)}
                      >
                        <FontAwesomeIcon icon={faEdit} />
                      </Button>
                    )}
                    <Button
                      size="sm"
                      variant="link"
                      title={intl.formatMessage({ id: messagePrefix + ".add" })}
                      onClick={this.handleAddQuestionChoice.bind(this)}
                    >
                      <FontAwesomeIcon icon={faPlusSquare} />
                    </Button>

                    <TrashButton
                      onClick={this.handleDeleteQuestionChoice.bind(this)}
                      titleId={messagePrefix + ".delete"}
                      disabled={!!coalesce(ObjectUtils.getDeepProperty(question, choiceName, "length"), 0)}
                    />

                  </ButtonGroup>
                </ButtonToolbar>
              </Col>
            </Row>
            <Row className="mt-3">
              <Col>
                {(question.type === "checkbox" || (question.editSubchoice && question.tempChoiceType === "Checkbox")) && (
                  <FormGroup  className="mb-3">
                    <Checkbox
                      inline
                      name={question.name}
                      onChange={(e) =>
                        this.handleQuestionChange(
                          e,
                          question.tempChoiceType ? "tempChoiceExclusive" : "choiceExclusive",
                          choiceName
                        )
                      }
                      checked={checkedExclusive}
                    >
                      <FormattedMessage id="survey.editor.exclusive" />
                    </Checkbox>
                    <InfoTooltip infoText={intl.formatMessage({ id: "survey.editor.exclusive.info" })} />
                  </FormGroup>
                )}
                {showRequiredToggle && (
                  <FormGroup  className="mb-3">
                    <Checkbox
                      inline
                      disabled={!editable}
                      checked={required}
                      onChange={this.handleRequiredChanged.bind(this)}
                    >
                      <FormattedMessage id="survey.editor.required" />
                    </Checkbox>
                    <InfoTooltip infoText={intl.formatMessage({ id: "survey.editor.required.info" })} />
                  </FormGroup>
                )}
                {showVisibleToggle && (
                  <FormGroup  className="mb-3">
                    <Checkbox checked={visible} onChange={this.handleVisibleChanged.bind(this)}>
                      <FormattedMessage id="survey.editor.visible" />
                    </Checkbox>
                  </FormGroup>
                )}
                <FormGroup className="d-flex align-items-center mb-3">
                  <Checkbox inline checked={showInfotext} onChange={this.handleDescriptionView.bind(this)}>
                    <FormattedMessage id="survey.editor.infotext" />
                  </Checkbox>
                  {showInfotext && (
                    <FormControl
                      size="sm"
                      name="description"
                      value={infoText || ""}
                      onChange={(e) => this.handleChange(e, "infoText")}
                    />
                  )}
                </FormGroup>

                <FormGroup className="d-flex flex-center align-items-center gap-lg mb-3">
                  <FormLabel className="m-0">
                    <FormattedMessage id={choiceKey_Prefix} />
                  </FormLabel>
                  <FormControl
                    size="sm"
                    readOnly={!this.state.showQuestionKey}
                    disabled={!editable}
                    type="text"
                    className="d-inline-flex text-long"
                    name={`${choiceName}-key`}
                    value={choiceKey}
                    onChange={(e) => this.handleChange(e, "key")}
                  />
                  <Visibility roles={[ADMIN, SURVEY_KEY_EDITOR]}>
                    <Button
                      size="sm"
                      variant="link"
                      inline
                      onClick={() => this.setState({ showQuestionKey: !this.state.showQuestionKey })}
                    >
                      <FontAwesomeIcon icon={this.state.showQuestionKey ? faTimes : faEdit} />
                    </Button>
                  </Visibility>
                </FormGroup>
              </Col>
            </Row>
          </div>
        </Container>
    );
  }
}

Choice.propTypes = {
  editable: PropTypes.bool,
  required: PropTypes.bool,
  visible: PropTypes.bool,
  choiceName: PropTypes.string,
  choiceText: PropTypes.string,
  pageName: PropTypes.string,
  letter: PropTypes.number,
  type: PropTypes.string,
  infoText: PropTypes.string,
  choiceTarget: PropTypes.string,
  exclusiveName: PropTypes.string,
  question: PropTypes.object,
  intl: PropTypes.object,
  choiceDescriptionVisible: PropTypes.bool,
  hasSubchoice: PropTypes.bool,
  setValidator: PropTypes.func,
  setValidatorProperty: PropTypes.func,
  changeQuestionField: PropTypes.func,
  addQuestionChoice: PropTypes.func,
  removeQuestionChoice: PropTypes.func,
  reorderChoice: PropTypes.func,
  confirmSubchoice: PropTypes.func,
  cancelSubchoice: PropTypes.func,
  loadPredefinedList: PropTypes.func,
  editSubchoice: PropTypes.func,
  showRequiredToggle: PropTypes.bool,
  showVisibleToggle: PropTypes.bool
};

Choice.defaultProps = {
  visible: true,
  showRequiredToggle: true,
  showVisibleToggle: false
};

const SubchoiceType = ({ hasSubchoice, tableChoiceType, onSelect, intl, disabled }) => {
  const typeLabel = {
    Number: "survey.editor.table.number",
    Text: "survey.editor.table.text",
    Date: "survey.editor.table.date",
    Radio: "survey.editor.table.singleChoice",
    Checkbox: "survey.editor.table.multipleChoice",
    Dropdown: "survey.editor.table.singleChoice",
    predefinedList: "survey.editor.table.singleChoice",
    activityList: "survey.editor.activity.list",
    _: "app.common.Select"
  };

  tableChoiceType = coalesce(tableChoiceType, "_");

  return hasSubchoice ? (
    <Dropdown
      id="questionTypeDropDown"
      onSelect={(eventKey) => onSelect("type", eventKey)}
      defaultValue={intl.formatMessage({ id: typeLabel[tableChoiceType] })}
    >
      <DropdownToggle className={"w-100 flex-center-between"} disabled={disabled}>
        <FormattedMessage id={typeLabel[tableChoiceType]} />
      </DropdownToggle>
      <DropdownMenu>
        <DropdownItem eventKey="Text">{intl.formatMessage({ id: typeLabel["Text"] })}</DropdownItem>
        <DropdownItem eventKey="Checkbox">{intl.formatMessage({ id: typeLabel["Checkbox"] })}</DropdownItem>
        <DropdownItem eventKey="Radio">{intl.formatMessage({ id: typeLabel["Radio"] })}</DropdownItem>
        <DropdownItem eventKey="Number">{intl.formatMessage({ id: typeLabel["Number"] })}</DropdownItem>
        <DropdownItem eventKey="Date">{intl.formatMessage({ id: typeLabel["Date"] })}</DropdownItem>
      </DropdownMenu>
    </Dropdown>
  ) : (
    <></>
  );
};

SubchoiceType.propTypes = {
  intl: PropTypes.object,
  onSelect: PropTypes.func,
  tableChoiceType: PropTypes.string,
  hasSubchoice: PropTypes.bool,
  disabled: PropTypes.bool
};

const SubChoicePopup = ({
  hasSubchoice,
  pageName,
  question,
  editable,
  onClose,
  onConfirm,
  parentChoiceName,
  choiceType,
  setValidator,
  setValidatorProperty,
  changeQuestionField,
  addQuestionChoice,
  removeQuestionChoice,
  reorderChoice,
  letter,
  intl,
  loadPredefinedList
}) => {
  let result = <></>;

  const { editSubchoice } = question;

  if (hasSubchoice && editSubchoice === parentChoiceName) {
    let configElement = null;
    let predefinedProps = {
      validators: "tempValidators",
      suffix: "tempSuffix"
    };
    let typeElement = null;
    switch (coalesce(question.tempChoiceType, choiceType)) {
      case "Text":
        predefinedProps = { validators: "tempValidators" };
        configElement = Text.Config({
          changeQuestionField,
          pageName,
          question,
          setValidator,
          predefinedProps,
          columnName: parentChoiceName,
          editable
        });
        break;

      case "Number":
        configElement = Number.Config({
          pageName,
          question,
          setValidatorProperty,
          changeQuestionField,
          columnName: parentChoiceName,
          predefinedProps,
          editable
        });
        break;

      case "Date":
        configElement = Date.Config({
          pageName,
          question,
          setValidatorProperty,
          columnName: "dateFormat",
          intl,
          editable
        });
        break;

      case "predefinedList":
        configElement = MultiChoice.Predefined({
          pageName,
          question,
          editable,
          changeQuestionField,
          addQuestionChoice,
          removeQuestionChoice,
          reorderChoice,
          choiceTarget: "tempChoices",
          parentChoiceName,
          parentChoiceTarget: "tempChoices",
          otherOptionField: TEMP_OTHER_OPTION,
          intl,
          loadPredefinedList
        });
      // eslint-disable-next-line no-fallthrough
      case "Radio":
      case "Dropdown":
        configElement =
          configElement ||
          MultiChoice.Config({
            pageName,
            question,
            editable,
            changeQuestionField,
            addQuestionChoice,
            removeQuestionChoice,
            reorderChoice,
            choiceTarget: "tempChoices",
            parentChoiceName,
            parentChoiceTarget: "tempChoices",
            otherOptionField: TEMP_OTHER_OPTION
          });

        typeElement = (
          <FormGroup className="mb-3" controlId="tempChoiceType">
            <Radio
              name="tempChoiceType"
              value="radio"
              disabled={!editable}
              checked={question.tempChoiceType === "Radio"}
              onChange={() =>
                changeQuestionField(pageName, question.name, "tempChoiceType", "Radio", "", question.tempChoiceType)
              }
            >
              <FormattedMessage id="survey.editor.toolbox.radioButton" />
            </Radio>
            <Radio
              name="tempChoiceType"
              value="dropdown"
              disabled={!editable}
              checked={question.tempChoiceType === "Dropdown"}
              onChange={() =>
                changeQuestionField(pageName, question.name, "tempChoiceType", "Dropdown", "", question.tempChoiceType)
              }
            >
              <FormattedMessage id="survey.editor.toolbox.dropdown" />
            </Radio>
            <Radio
              name="tempChoiceType"
              value="predefinedList"
              disabled={!editable}
              checked={question.tempChoiceType === "predefinedList"}
              onChange={() =>
                changeQuestionField(
                  pageName,
                  question.name,
                  "tempChoiceType",
                  "predefinedList",
                  "",
                  question.tempChoiceType
                )
              }
            >
              <FormattedMessage id="survey.editor.toolbox.predefinedList" />{" "}
              <InfoTooltip infoText={intl.formatMessage({ id: "survey.editor.toolbox.predefinedList.info" })} />
            </Radio>
          </FormGroup>
        );
        break;

      case "Checkbox":
        configElement = MultiChoice.Config({
          pageName,
          question,
          editable,
          changeQuestionField,
          addQuestionChoice,
          removeQuestionChoice,
          reorderChoice,
          choiceTarget: "tempChoices",
          parentChoiceName,
          parentChoiceTarget: "tempChoices",
          showExclusive: true,
          exclusiveName: "tempChoiceExclusive",
          otherOptionField: TEMP_OTHER_OPTION
        });
        break;

      default:
        break;
    }

    result = (
      <Modal show size={"xl"}>
        <ModalHeader>
          <ModalTitle>
            <QuestionIcon type={choiceType} className="mx-2" />
            <FormattedMessage id="survey.editor.matrix.column.choice" />
            <Circle bg="light">{String.fromCharCode(letter)}</Circle>
          </ModalTitle>
        </ModalHeader>
        <Modal.Body>
          <FormGroup  className="mb-3">
            <FormControl
              name="title"
              type="text"
              readOnly={!editable}
              onChange={(e) => changeQuestionField(pageName, question.name, "tempChoiceText", e.target.value)}
              value={question.tempChoiceText}
            />
          </FormGroup>
          {typeElement}
          {configElement}
        </Modal.Body>
        <Modal.Footer>
          <Button onClick={onClose} variant="secondary">
            <FormattedMessage id="app.common.Cancel" />
          </Button>
          <Button onClick={onConfirm}>
            <FormattedMessage id="survey.editor.save" />
          </Button>
        </Modal.Footer>
      </Modal>
    );
  }
  return result;
};

export default injectIntl(Choice);
